import styled from 'styled-components';

const ShareGiftPreviewWrapper = styled.div`
  display: flex;
  gap: 16px;
  overflow-y: scroll;
  width: 100%;
`;

const Form = styled.form`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const FormInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const Col1 = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 8px;
  width: 50%;
`;

const Col2 = styled.div`
  border: 1px solid var(--color-gray-200);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding: 8px 16px;
  width: 50%;
`;

const EmptyContentWrapper = styled.div`
  align-items: center;
  color: var(--color-accent-secondary-default);
  display: flex;
  font-style: italic;
  height: 100%;
  justify-content: center;
  text-align: center;
`;

const MemberContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const SuccessfulContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

const SuccessIconWrapper = styled.div`
  align-items: center;
  border: 1px solid var(--color-success-default);
  border-radius: var(--size-border-radius-circle);
  display: flex;
  height: 80px;
  justify-content: center;
  margin-bottom: 8px;
  width: 80px;
`;

const ShareGiftPreviewContent = styled.div`
  border-radius: var(--size-border-radius-md);
  height: 100%;
`;

export {
  Col1,
  Col2,
  EmptyContentWrapper,
  Form,
  FormInputWrapper,
  MemberContentWrapper,
  ShareGiftPreviewContent,
  ShareGiftPreviewWrapper,
  SuccessIconWrapper,
  SuccessfulContentWrapper
};
